import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Card, AppBar, Tabs, Tab, Button, Paper, CardHeader, Grid } from '@material-ui/core';
import styled from 'styled-components';
import { Text, Subtitle } from '../../../helpers/Typography';
import axios from 'axios';
import { routesApi } from '../../../setup/routes';
import { withCookies } from 'react-cookie';
import { CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const StyledCard = styled(Card)`
  height: 505px;
  overflow: auto;
`;

const StyledPaper = styled(Paper)`
  height: 505px;
  overflow: auto;
`;

const Container = styled.div`
  && {
    display: flex;
    flex-flow: row wrap;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
  }
`;

const ContainerReverse = styled.div`
  && {
    display: flex;
    flex-flow: row wrap;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-bottom: 20px;
  }
`;

const StyledTabs = styled(Tabs)`
  && {
    margin: 0;
  }
`;

const StyledTab = styled(Tab)`
  && {
    min-width: 50px;
    text-transform: initial;
  }
`;

const CardMargin = styled.div`
  && {
    margin: 4%;
  }
`;

const styles = theme => ({
  tabIndicator: {
    backgroundColor: "#1b2642",
    // top: 0
  },
  cardTitle: {
    color: 'white',
    fontSize: "19px",
    fontFamily: 'Lato',
  },
  tabRoot: {
    backgroundColor: "#7792d8", 
    color: "#FFFFFF",
    opacity: 1
  },
  selected: {
    backgroundColor: "#FFFFFF",
    color: "#000000"
  }
});

class ProjectBriefComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: undefined,
      value: 0,
      file: undefined
    }
  }

  componentDidMount() {

  }

  static getDerivedStateFromProps(props, state) {
    if (props.project !== state.project) {
      return {
        project: props.project,
      };
    }
    return null;
  }

  componentWillUnmount() {
    this.setState({ project: undefined });
  }

  uploadEvaluation = async () => {
    try {
      // eslint-disable-next-line no-undef
      let formData = new FormData();
      await formData.append("file", this.state.evaluationFile, this.state.evaluationFile.name);
      const token = this.props.cookies.get("token");
      const headers = { Authorization: `Bearer ${token}`, 'content-type': 'multipart/form-data' };
      const request = axios.post(routesApi.projects.uploadEvaluation(this.state.project.id), formData, { headers });
      const response = await request;
      if (response.status === 200)
        this.props.reload();
    } catch (error) {
      // eslint-disable-next-line no-undef
      console.log({ error });
    }
  }

  uploadGantt = async () => {
    try {
      // eslint-disable-next-line no-undef
      let formData = new FormData();
      await formData.append("file", this.state.ganttFile, this.state.ganttFile.name);
      const token = this.props.cookies.get("token");
      const headers = { Authorization: `Bearer ${token}`, 'content-type': 'multipart/form-data' };
      const request = axios.post(routesApi.projects.uploadGantt(this.state.project.id), formData, { headers });
      const response = await request;
      if (response.status === 200)
        this.props.reload();
    } catch (error) {
      // eslint-disable-next-line no-undef
      console.log({ error });
    }
  }

  downloadEvaluation = async () => {
    try {
      const token = this.props.cookies.get("token");
      const headers = { Authorization: `Bearer ${token}` };
      const requestUrl = axios.get(routesApi.projects.getEvaluation(this.state.project.economicEvaluationFile), { headers });
      const responseUrl = await requestUrl;
      // eslint-disable-next-line no-undef
      window.open(responseUrl.data.url, "_blank");
    } catch (error) {
      // eslint-disable-next-line no-undef
      console.log({ error });
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  }

  render() {
    const { classes } = this.props;
    return (
      <StyledPaper>
        <StyledCard>
          <CardHeader title="Descripción del Proyecto" classes={{ title: classes.cardTitle }} style={{backgroundColor: '#1b2642', height: '33px'}} />
          <div>
            {!this.state.project ? <div style={{ display: "flex", justifyContent: "center" }}> <CircularProgress size={100} thickness={6} /> </div> : (
              <div>
                <AppBar color="inherit" elevation={0} position="static" style={{ width: "100%", boxShadow: 'none' }}>
                  <StyledTabs classes={{ indicator: classes.tabIndicator }} value={this.state.value} onChange={this.handleChange} variant="fullWidth">
                    <StyledTab classes={{selected: classes.selected, root: classes.tabRoot}} label="Resumen" />
                    <StyledTab classes={{selected: classes.selected, root: classes.tabRoot}} label="Problema" />
                    <StyledTab classes={{selected: classes.selected, root: classes.tabRoot}} label="Solución" />
                    <StyledTab classes={{selected: classes.selected, root: classes.tabRoot}} label="Beneficios" />
                  </StyledTabs>
                </AppBar>
                <CardMargin>
                  <div>
                    {this.state.value === 0 &&
                      <Grid container direction="column" justify="space-between">
                        <Grid item xs={"auto"}>
                          <div>
                            <Text style={this.state.project.problem.length > 150 ? { minHeight: 340, columnCount: 2, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 } : { minHeight: 340, columnCount: 1, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 }}>
                              {this.state.project.problem}
                            </Text>
                          </div>
                        </Grid>
                        {this.props.edit && (
                        <Grid item xs={"auto"}>
                          <Grid container justify="flex-end">
                          <Button 
                              style={{ backgroundColor: "#009688", color: "#FFFF" }} 
                              onClick={() => this.props.openEditDetails("resume")}
                            >
                              Editar
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                      </Grid>
                      }
                    {this.state.value === 1 &&
                      <Grid container direction="column" justify="space-between">
                        <Grid item xs={"auto"}>
                          <div>
                          <Text style={this.state.project.solution.length > 150 ? { minHeight: 340, columnCount: 2, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 } : { minHeight: 340, columnCount: 1, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 }}>
                            {this.state.project.solution}
                          </Text>
                          </div>
                        </Grid>
                        {this.props.edit && (
                        <Grid item xs={"auto"}>
                          <Grid container justify="flex-end">
                          <Button 
                              style={{ backgroundColor: "#009688", color: "#FFFF" }} 
                              onClick={() => this.props.openEditDetails("solution")}
                            >
                              Editar
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                      </Grid>
                      }
                    {this.state.value === 2 &&
                      <Grid container direction="column" justify="space-between">
                        <Grid item xs={"auto"}>
                          <div>
                          <Text style={this.state.project.objetives.length > 150 ? { minHeight: 340, columnCount: 2, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 } : { minHeight: 340, columnCount: 1, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 }}>
                            {this.state.project.objetives}
                          </Text>
                          </div>
                        </Grid>
                        {this.props.edit && (
                        <Grid item xs={"auto"}>
                          <Grid container justify="flex-end">
                          <Button 
                              style={{ backgroundColor: "#009688", color: "#FFFF" }} 
                              onClick={() => this.props.openEditDetails("objetives")}
                            >
                              Editar
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                      </Grid>
                      }
                    {this.state.value === 3 &&
                      <Grid container direction="column" justify="space-between">
                        <Grid item xs={"auto"}>
                          <div>
                            <Text style={this.state.project.benefits.length > 150 ? { minHeight: 340, columnCount: 2, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 } : { minHeight: 340, columnCount: 1, whiteSpace: "pre-line", color: "#000000", lineHeight: 1.4 }}>
                              {this.state.project.benefits}
                            </Text>
                          </div>
                        </Grid>
                        {this.props.edit && (
                        <Grid item xs={"auto"}>
                          <Grid container justify="flex-end">
                          <Button 
                              style={{ backgroundColor: "#009688", color: "#FFFF" }} 
                              onClick={() => this.props.openEditDetails("benefits")}
                            >
                              Editar
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                      </Grid>
                      }
                  </div>
                </CardMargin>
              </div>
            )}
          </div>
        </StyledCard>
      </StyledPaper>
    );
  }
}

ProjectBriefComponent.propTypes = {
  cookies: PropTypes.object,
  periods: PropTypes.array,
  isLoading: PropTypes.bool,
  company: PropTypes.object,
  classes: PropTypes.object,
  error: PropTypes.bool,
  reload: PropTypes.func,

};

function mapStateToProps(state) {
  return {
    project: state.projects.project,
    periods: state.periods.periods,
    isLoading: state.projects.isLoading,
    company: state.companies.company,
    error: state.projects.error
  };
}

export default connect(mapStateToProps)(withCookies(withStyles(styles)(ProjectBriefComponent)));
